import RoomsInput from './RoomsInput'

export default RoomsInput
